import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
} from '@angular/router';

const DEAL_ROUTE_PATH = 'deal/:itemId';

// Every deal shares this one Route config, so default reuse keeps a stale
// ItemDialogComponent when only the id changes.
@Injectable({ providedIn: 'root' })
export class DealRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    if (!super.shouldReuseRoute(future, curr)) {
      return false;
    }
    if (future.routeConfig?.path !== DEAL_ROUTE_PATH) {
      return true;
    }
    return future.params['itemId'] === curr.params['itemId'];
  }
}
